import { Subscription } from 'rxjs'
import { tap } from 'rxjs/operators'
import { isNil } from 'ramda'
import { RendererOptions } from 'instantsearch.js'
import connectAutocomplete, {
    AutocompleteConnectorParams as CParams,
    AutocompleteWidgetDescription as WDescription,
} from 'instantsearch.js/es/connectors/autocomplete/connectAutocomplete'

import { Component, OnInit, Inject, forwardRef, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core'

import { SearchService } from '@app-services'
import { InstantsearchComponent } from '@app-domains/instantsearch/components/instantsearch.component'
import { AbstractInstantsearchWidgetComponent } from '@app-domains/instantsearch/abstract-instantsearch-widget.component'
import { Product } from '@app-domains/content-blocks/components/product-card/product-card.types'

@Component({
    selector: 'app-search-hits-products',
    templateUrl: './search-hits-products.component.html',
    styleUrls: ['../search/search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class SearchHitsProductsComponent extends AbstractInstantsearchWidgetComponent<
WDescription,
CParams
> implements OnInit, OnDestroy {

    public override readonly widgetName = 'SearchHitsProductsComponent'

    @Output()
    public resultClicked = new EventEmitter<void>()

    @Output()
    public loading = new EventEmitter<boolean>()

    public override updateState = (
        state: WDescription['renderState'] & RendererOptions<CParams>,
    ) => {
        this.state = state
        this.loading.emit(false)
    }

    private subscription: Subscription

    constructor(
        @Inject(forwardRef(() => InstantsearchComponent))
        public instantSearchInstance: InstantsearchComponent,
        private searchService: SearchService,
    ) {
        super()
    }

    public override ngOnInit(): void {
        this.createWidget(connectAutocomplete, {})
        super.ngOnInit()

        this.subscription = this.searchService.query$.pipe(
            tap((query) => {
                if (isNil(query)) {
                    return
                }

                if (query.length >= 3) {
                    this.state?.refine(query)
                    this.loading.emit(true)
                } else if (this.state) {
                    this.state.indices.forEach((index) => {
                        index.hits = []
                    })
                }
            }),
        ).subscribe()
    }


    public resultClick(product: Product): void {

        this.resultClicked.emit()
        this.searchService.addRecentSearch(product)
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy()
        this.subscription.unsubscribe()
    }
}
